// returns date as seconds since Jan 1, 1970
export const getCurrentUnixTimestamp = () => Math.round((new Date()).getTime() / 1000);
